<section class="tw-fixed tw-z-10 tw-w-full lg:tw-w-auto tw-top-16 lg:tw-top-auto">
  <div>
    <h1 class="tw-text-lg md:tw-text-xl tw-font-bold lg:tw-hidden tw-bg-white dark:tw-bg-gray-800 tw-px-4 tw-py-3 dark:tw-text-gray-100 tw-shadow-[0px_1px_2px_0px_#00000014]">
      {{ 'v2.orgSettings.organizationSettings' | translate }}
    </h1>
  </div>
  <div
    class="scrollbar-hide-md tw-overflow-x-auto tw-overflow-y-hidden lg:tw-overflow-visible lg:tw-w-[256px] lg:tw-h-screen tw-bg-gray-100 dark:tw-bg-gray-900 lg:tw-bg-white lg:dark:tw-bg-gray-800"
  >
    <ul
      class="tw-bg-gray-100 dark:tw-bg-gray-900 lg:tw-bg-white lg:dark:tw-bg-gray-800 tw-p-4 tw-pb-4 md:tw-pt-4 md:tw-pb-1 tw-flex tw-w-full tw-text-sm tw-font-medium tw-text-center tw-gap-3 lg:tw-gap-4 lg:tw-flex-col lg:tw-text-left lg:tw-pt-10 lg:tw-pl-4 md:tw-pl-[20%]"
    >
      @for (tab of tabs(); track $index) {
      <li class="tw-flex-1 lg:tw-flex-none tw-bg-gray-100 dark:tw-bg-gray-900 tw-rounded-md py-[10px]">
        <a
          class="tw-gap-1 lg:tw-gap-2 tw-text-sm tw-font-medium nav-button tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-group tw-w-full tw-cursor-pointer tw-py-2 tw-px-4 md:tw-py-3 lg:tw-justify-start lg:tw-text-left lg:tw-py-[10px]"
          [ngClass]="{
            'tw-text-white tw-bg-blue-600 tw-border-blue-600 dark:tw-bg-blue-600 dark:tw-text-white hover:tw-text-white': activeStates[tab.name],
            'hover:tw-text-gray-600 tw-border-transparent hover:tw-border-gray-300 dark:hover:tw-text-gray-300 tw-text-gray-500 group-hover:tw-text-gray-500 dark:tw-text-gray-400 dark:group-hover:tw-text-gray-300':
              !activeStates[tab.name]
          }"
          (click)="onTabClick(tab)"
        >
          <span [innerHTML]="getIcon(tab)"></span>
          <span class="tw-font-inter">{{ tab.label | translate }}</span>
        </a>
      </li>
      }
    </ul>
  </div>
</section>
